import { useCallback } from 'react';
import moment from 'moment';
import {
  TRAUMA_LABELS,
  TRAUMA_COLORS,
  STATUS_COLORS,
  STATUS_LABELS,
  CONCIERGE_COLORS,
  BILLING_COLORS,
  BILLING_STATUS_TEXT,
  STATUS_MAP,
} from './enquiryConstants';

export const useEnquiryUtils = () => {
  const convertUTCToLocal = useCallback((date, format = 'MM-DD-YYYY, HH:mm:ss') => {
    if (!date) return '';
    return moment.utc(date).local().format(format);
  }, []);

  const formatDate = useCallback((date) => {
    return moment(date).isValid() ? moment(date).format('MM/DD/YYYY') : '';
  }, []);

  const getTraumaLabel = useCallback((status) => {
    return TRAUMA_LABELS[status] || { main: '', sub: '' };
  }, []);

  const getTraumaColor = useCallback((status) => {
    return TRAUMA_COLORS[status] || 'black';
  }, []);

  const getStatusStyle = useCallback((status) => {
    const borderColor = STATUS_COLORS[status] || 'black';
    return {
      border: '1px solid',
      borderColor,
      padding: '5px',
      color: borderColor,
      display: 'inline-block',
      borderRadius: '5px',
    };
  }, []);

  const getStatusLabel = useCallback((status) => STATUS_LABELS[status] || '', []);

  const getConciergeStyle = useCallback(
    (status) => ({ color: CONCIERGE_COLORS[status] || '#3D3BA4' }),
    []
  );

  const getBillingStyle = useCallback(
    (status) => ({ color: BILLING_COLORS[status] || '#3D3BA4' }),
    []
  );

  const getBillingStatusText = useCallback((status) => BILLING_STATUS_TEXT[status] || '', []);

  const getConciergeStatusText = useCallback((status) => STATUS_MAP[status] || '', []);

  const renderTraumaStatus = useCallback(
    (traumaStatus) => {
      const trauma = getTraumaLabel(traumaStatus);
      if (!trauma.main) return null;
      const color = getTraumaColor(traumaStatus);
      return (
        <>
          <span style={{ color: 'black' }}>{trauma.main}</span>
          {trauma.sub && (
            <>
              {' '}(<span style={{ color }}>{trauma.sub}</span>)
            </>
          )}
        </>
      );
    },
    [getTraumaLabel, getTraumaColor]
  );

  return {
    convertUTCToLocal,
    formatDate,
    getTraumaLabel,
    getTraumaColor,
    getStatusStyle,
    getStatusLabel,
    getConciergeStyle,
    getBillingStyle,
    getBillingStatusText,
    getConciergeStatusText,
    renderTraumaStatus,
  };
};
